/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, May 11th 2023, 12:39:08 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { withAccessCheck } from "authorization/hoc";
import { useGlobalScope } from "core/providers";
import { getDefaultAIAgentConfiguration } from "lib/factories";
import { AIAgentConfiguration, AIProviders } from "lib/schemas";
import { useAIWorkersAPI } from "ai-workers/services/AIWorkersAPI";
import { TranslatableTextAreaInput } from "translation/components";
import { OSAPIForm } from "ui-widgets";
import { TextFormInput, DropDownFormInput } from "ui-widgets/forms";

type UseAIAgentConfigurationsAPIFormFunction = ReturnType<typeof useAIWorkersAPI>["useAIAgentConfigurationsAPIForm"];

type AIAgentConfigurationFormProps = Parameters<UseAIAgentConfigurationsAPIFormFunction>[0] & {};

export const AIAgentConfigurationForm = withAccessCheck(
  { resourceId: "configureAIWorkers" },
  ({
    aiAgentConfigurationDefaultValues,
    aiAgentConfigurationFetchId,
    updateAIAgentConfigurationFromAPICallback,
  }: AIAgentConfigurationFormProps) => {
    const {
      globalState: { selectedOrganization },
    } = useGlobalScope();
    const { useAIAgentConfigurationsAPIForm } = useAIWorkersAPI();
    const useAPIFormReturn = useAIAgentConfigurationsAPIForm({
      aiAgentConfigurationDefaultValues:
        aiAgentConfigurationDefaultValues || getDefaultAIAgentConfiguration(selectedOrganization),
      aiAgentConfigurationFetchId,
      updateAIAgentConfigurationFromAPICallback,
    });
    return (
      <OSAPIForm useAPIFormReturn={useAPIFormReturn}>
        <TextFormInput<AIAgentConfiguration> schema_field_key="name" label="Name" />
        <DropDownFormInput<AIAgentConfiguration>
          schema_field_key="provider_code"
          label="AI Provider"
          options={AIProviders}
        />
        <TextFormInput<AIAgentConfiguration> schema_field_key="model_identifier" label="Model Identifier" />
        <TranslatableTextAreaInput<AIAgentConfiguration> schema_field_key="prompt" label="Instructions" />
        <TranslatableTextAreaInput<AIAgentConfiguration> schema_field_key="input" label="Input" />
      </OSAPIForm>
    );
  }
);
